<template>
	<div class="g-page flex">
		<div style="position: fixed; top: -100px;">
			<input type="text" name="username">
			<input type="password" name="password">
		</div>

		<div v-show="!windowPage" class="g-nav flex-column">
			<div class="logo flex-column flex-center" :title="saasInfo.saas_name" @click="navigateTo('/system/factory')">
				<div class="logo-image flex-center">
					<img :src="saasInfo.saas_logo || require('@/assets/image/icon.png')" alt="">
				</div>
				<p class="name ellipsis-2">{{saasInfo.saas_name}}</p>
				<span v-if="freeEdition" class="tag" style="color: #fff; background: #0D6EFE;" @click.stop="navigateTo('/upgrade')">免费版{{saasInfo.remaining_effective_days <= 30 ? ` 剩余${saasInfo.remaining_effective_days}天` : ''}}</span>
				<span v-else-if="saasInfo.remaining_effective_days <= 60" class="tag" style="color: #FF0000; background: #FFEDED;">剩余{{saasInfo.remaining_effective_days}}天</span>
				<span class="edit flex-center"><i class="tf-edit"></i></span>
			</div>
			<c-scroll class="flex-grow" bar-color="rgba(255,255,255,.2)">
				<ul class="nav">
					<li v-for="(nav, i) in navList" :key="i" class="item flex-center" :class="{'z-alive': aliveNav == nav.menu_unique_key}" :group="nav.group" @click="navHandle(nav)">
						<i class="icon tf" :class="`tf-nav-${nav.menu_unique_key}`"></i>
						<p class="flex-grow">{{nav.menu_name}}</p>
					</li>
				</ul>
			</c-scroll>
			<div class="bottom flex-center">
				<img src="@/assets/image/logo.png" alt="">
			</div>
		</div>

		<div v-show="!windowPage && aliveNavData.child_menu_list && aliveNavData.child_menu_list.length" class="g-menu flex-column">
			<div class="g-menu-title">{{aliveNavData.menu_name}}</div>
			<c-scroll class="g-menu-list flex-grow">
				<dl v-for="(menu, i) in aliveNavData.child_menu_list" :key="i" :ref="`menu-${i}`" class="item">
					<dt>{{menu.menu_name}}</dt>
					<dd>
						<ul>
							<li v-for="(item, j) in menu.child_menu_list" :key="j" class="flex-center-cross" :class="{'z-alive': alivePage == item.menu_unique_key}" @click="menuHandle(item)" @mouseup="e => e.which == 2 ? menuHandle(item, true) : ''">
								<p>{{item.menu_name}}<span v-if="item.is_builtin">（内置）</span></p>
								<img v-if="!item.is_builtin && lock(item.menu_unique_key)" class="vip" src="@/assets/image/vip.png">
								<div v-if="item.window" class="window flex-center" title="新窗口打开"><i class="tf" @click.stop="menuHandle(item, true)">&#xe639;</i></div>
							</li>
						</ul>
					</dd>
				</dl>
			</c-scroll>
		</div>

		<div class="flex-grow flex-column">
			<div v-show="!windowPage" class="g-head flex">
				<div class="flex-grow flex-between-center">
					<div class="head-crumb flex-center">
						<template v-for="(item, i) in crumbList">
							<span v-if="i > 0"><i class="tf">&#xeb08;</i></span>
							<p>{{item}}</p>
						</template>
					</div>
						
					<div class="flex">
						<div v-for="(item, i) in headButtonList" :key="i" class="head-button" :active="activeHeadButton == item">
							<div class="head-button-main flex-center" @click.stop="headButtonHandle(item)">
								<i class="icon" :class="[item.icon]"></i>
								<span>{{item.name}}</span>
								<img v-if="item.lock" class="vip" src="@/assets/image/vip.png">
							</div>
							<ul v-if="item.list" class="head-button-list">
								<li v-for="(child, j) in item.list" :key="j" class="flex-center-cross" @click.stop="headButtonHandle(child)">{{child.name}}</li>
							</ul>
						</div>
						<div v-if="headButtonList.length" class="head-button-line"></div>
						<div class="head-button">
							<div class="head-button-main flex-center">
								<i class="icon tf-phone"></i>
								<span>移动端入口</span>
							</div>
							<ul class="head-button-service">
								<li>蜂鸟工单【手机端】<i class="tf-tri-right" style="font-size: 10px;"></i>
									<div class="mobile flex-column">
										<img v-if="systemConfig && systemConfig.mobile_type == 2" class="qrcode" src="@/assets/image/mp_code.jpg" alt="">
										<img v-else class="qrcode" src="@/assets/image/wechat_code.jpg" alt="">
										<p>微信扫一扫<span>进入手机端</span></p>
									</div>
								</li>
								<li>蜂鸟工单【PAD端】<i class="tf-tri-right" style="font-size: 10px;"></i>
									<div class="mobile flex-column">
										<img class="qrcode" src="@/assets/image/pad_code.jpg" alt="">
										<p>扫一扫下载<span>安卓PAD端</span></p>
									</div>
								</li>
							</ul>
						</div>
						<div class="head-button">
							<div class="head-button-main flex-center">
								<i class="icon tf-doc"></i>
								<span>帮助与咨询</span>
							</div>
							<ul class="head-button-service">
								<li @click.stop="$refs.businessService.open()">商务咨询</li>
								<li @click.stop="$refs.technologyService.open()">技术咨询</li>
								<li @click.stop="navigateTo('/video')">视频教程</li>
								<li @click.stop="helpDocHandle('pc_operations_guide')">电脑端文档</li>
								<li @click.stop="helpDocHandle('h5_operations_guide')">手机端文档</li>
								<li @click.stop="$refs.guide.init()">新手引导</li>
							</ul>
						</div>
						<div v-if="auth('b_factory_ai')" class="head-ai flex-center" id="webChat-bubble-tip">
							<img src="@/assets/image/ai.png" alt="">
						</div>
						<div class="user-info flex-center">
							<div class="icon flex-center">
								<img src="@/assets/image/head_icon.jpg" alt="">
							</div>
							<span class="name">{{userInfo.user_realname}}</span>
							<i class="arrow tf-tri-down"></i>
							
							<div class="menu">
								<div class="item" @click="showUpdateLog">
									<span>更新日志</span>
									<div v-if="updateLogDot" class="dot"></div>
								</div>
								<div class="item" @click="$refs.resetPswForm.clear(); $refs.resetPsw.open()">修改密码</div>
								<div class="item" @click="logout">安全退出</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div v-if="notice" class="g-notice flex-center">
				<i class="tf">&#xe621;</i>
				<div class="content flex-grow flex">
					<div class="flex" :class="{'content-scroll': noticeScroll}" :style="{'animation-duration': `${noticeScroll / 25}s`}">
						<p ref="notice">{{notice}}</p>
						<p v-if="noticeScroll">{{notice}}</p>
					</div>
				</div>
			</div>
			
			<div class="g-content flex-grow">
				<router-view v-if="initialized" ref="routerView"></router-view>
			</div>
		</div>
		
		<c-dialog ref="updateLog" title="更新日志" width="900" height="680" button-name="关闭" :cancel-button="false">
			<div ref="updateLogList">
				<dl v-for="(item, i) in updateLog" :key="i" class="update-log">
					<dt class="flex-between-center">
						<p class="version">{{item.version}}</p>
						<p class="date">
							<i class="tf">&#xe678;</i>
							<span>{{item.update_time}}</span>
						</p>
					</dt>
					<dd>{{item.remark}}</dd>
				</dl>
			</div>
		</c-dialog>
		
		<c-dialog ref="resetPsw" title="修改密码" width="440" @resolve="resetPassword">
			<c-form ref="resetPswForm">
				<c-form-item label="旧密码" required>
					<c-input type="password" name="old_pwd" visible></c-input>
				</c-form-item>
				<c-form-item label="新密码" required>
					<c-input type="password" name="user_pwd" visible></c-input>
				</c-form-item>
				<c-form-item label="确认密码" required>
					<c-input type="password" name="confirm_pwd" visible></c-input>
				</c-form-item>
			</c-form>
		</c-dialog>

		<template v-if="systemConfig">
			<c-dialog ref="technologyService" width="300" :title="false" :button="false">
				<div class="service-code flex-column flex-center">
					<i class="tf icon">&#xe61d;</i>
					<h1>技术问题添加下方官方微信</h1>
					<img :src="systemConfig.technology_qrcode" alt="">
					<p>微信扫一扫</p>
				</div>
			</c-dialog>

			<c-dialog ref="businessService" width="400" :title="false" :button="false">
				<div class="custom-service flex-column flex-center">
					<i class="tf icon">&#xe61d;</i>
					<h1>蜂鸟工单资深客户顾问</h1>
					<h2>云端协同、数字驱动，让数据和算法协助企业提升生产效率、实现数字化精益制造；</h2>
					<img :src="systemConfig.business_qrcode" alt="">
					<p>微信扫一扫咨询</p>
					<div class="tel flex-center">
						<i class="tf">&#xe679;</i>
						<b>{{systemConfig.business_phone}}</b>
					</div>
				</div>
			</c-dialog>
		</template>
		
		<c-dialog ref="helpDoc" mode="slide" title="帮助文档" width="1200" :button="false" mask-close :resize-button="['max']">
			<iframe class="help-doc" :src="helpDocSrc"></iframe>
		</c-dialog>

		<c-dialog ref="follow" :title="false" width="600" :button="false" :close-button="false">
			<div class="follow flex-column flex-center">
				<h1 class="follow-title">免费版注册成功！</h1>
				<div class="follow-content">
					<div class="follow-account flex-between-end">
						<div class="flex-grow">
							<p><i class="tf">&#xe672;</i>电脑端登录地址：https://web.ycmes.cn</p>
							<p><i class="tf">&#xe63a;</i>移动端登录地址：https://app.ycmes.cn</p>
							<p><i class="tf">&#xe67c;</i>工厂代码：{{loginInfo.saas_id}}</p>
							<p><i class="tf">&#xe676;</i>账号：{{loginInfo.user_name}}</p>
							<p><i class="tf">&#xe636;</i>密码：{{loginInfo.pwd}}</p>
						</div>
						<div class="flex-end"><c-link color="main" icon="tf-copy" @click="copyHandle">复制账号信息</c-link></div>
					</div>
					<dl class="follow-code">
						<dt>扫码<span>添加好友</span>自动激活账号并登录</dt>
						<dd class="flex-column flex-center">
							<img :src="followCode" alt="">
						</dd>
					</dl>
				</div>
				<div class="follow-bottom flex-center-cross">
					<i class="tf">&#xe61d;</i>
					<p>使用微信扫一扫，获取以下权益</p>
				</div>
				<div class="follow-rights flex-between">
					<ul>
						<li class="flex-center-cross">
							<i class="tf">&#xe65e;</i>
							<p>免费获得蜂鸟工单免费版</p>
						</li>
						<li class="flex-center-cross">
							<i class="tf">&#xe65e;</i>
							<p>多对一全角色服务</p>
						</li>
					</ul>
					<ul>
						<li class="flex-center-cross">
							<i class="tf">&#xe65e;</i>
							<p>免费获取实施方案资料</p>
						</li>
						<li class="flex-center-cross">
							<i class="tf">&#xe65e;</i>
							<p>实施经理在线答疑</p>
						</li>
					</ul>
				</div>
			</div>
		</c-dialog>

		<guide ref="guide"></guide>
		<system-remind v-if="renewRemind" ref="renewRemind" title="到期提醒" button-name="我要续期" @resolve="freeEdition ? $refs.renewConfirm.open() : $refs.businessService.open()">
			<p>您好！贵公司购买的蜂鸟工系统<span v-if="freeEdition">【免费版】</span><span v-else style="color: #FF0000;">【专业版】</span>使用期限<span style="font-weight: bold; color: #FF0000;">仅剩{{saasInfo.remaining_effective_days}}天</span>，到期时间截止{{saasInfo.auth_exp_date.replace('-', '年').replace('-', '月')}}日，为避免影响您的正常使用，请及时续期。</p>
		</system-remind>
		<renew-confirm v-if="freeEdition && renewRemind" ref="renewConfirm"></renew-confirm>
		<system-remind v-if="freeEdition" ref="uploadRemind" title="温馨提示" button-name="联系客服升级" @resolve="$refs.businessService.open()">
			<p>当前【免费版】上传文件大小上限为<span style="color: #FF0000;">5MB</span>，该文件已超出限制✨，<span style="color: #FF0000;">升级【专业版】</span>即可解除文件大小限制，体验更大文件上传能力哦。</p>
		</system-remind>
	</div>
</template>

<script>
	import guide from '@/components/service/guide'
	import systemRemind from '@/components/service/system_remind'
	import renewConfirm from '@/components/service/renew_confirm'
	import {cryptoJs} from '@deanwu/vue-component-library'
	import {mapState, mapGetters} from 'vuex'
	
	export default {
		name: 'Sys',

		components: {
			guide,
			systemRemind,
			renewConfirm
		},

		props: {
			windowPage: Boolean
		},

		data() {
			return {
				aliveNav: '',
				alivePage: '',

				crumbList: [],
				templateConfig: false,
				appViewConfig: false,
				activeHeadButton: null,

				updateLog: [],
				updateLogDot: false,
				helpDocSrc: '',
				followCode: '',
				loginInfo: {},

				pageButtonList: [],

				notice: '',
				noticeScroll: false
			}
		},
		
		computed: {
			...mapState(['saasInfo', 'userInfo', 'navList', 'systemConfig']),
			...mapGetters(['initialized', 'freeEdition']),

			aliveNavData() {
				return this.navList.find(item => item.menu_unique_key == this.aliveNav) || {};
			},
			
			headButtonList() {
				if (!this.initialized) return [];
				let arr = [];
				if (this.templateConfig) {
					arr.push({
						name: '模板管理',
						icon: 'tf-template',
						handle: () => {
							this.globalDialog('templateManage', {
								props: this.templateConfig
							})
						}
					});
				}

				if (this.appViewConfig) {
					let list = [];
					['extendView', 'detailView'].forEach(type => {
						if (this.appViewConfig[type]) {
							list = list.concat(
								this.appViewConfig[type].filter(item => !item.disabled || !item.disabled.call(this)).map(item => {
									return {
										name: item.name,
										handle: () => {
											this.globalDialog('appViewConfig', {
												props: item,
												data: {
													name: item.name,
													baseInfo: item.baseInfo === false ? false : true
												}
											})
										}
									}
								})
							)
						}
					});

					if (list.length && this.appViewConfig.viewId) {
						list.unshift({
							name: '列表卡片',
							handle: () => {
								this.globalDialog('appViewConfig', {
									props: this.appViewConfig,
									data: {
										name: '列表',
										baseInfo: this.appViewConfig.baseInfo === false ? false : true
									}
								})
							}
						});
					}

					arr.push({
						name: '移动端卡片管理',
						icon: 'tf-app-card',
						lock: this.lock(this.appViewConfig.auth),
						list: list.length ? list : null,
						handle: list.length ? null : () => {
							this.globalDialog('appViewConfig', {
								props: this.appViewConfig,
								data: {
									name: '列表',
									baseInfo: this.appViewConfig.baseInfo === false ? false : true
								}
							})
						}
					});
				}

				return this.pageButtonList.concat(arr);
			},

			renewRemind() {
				return this.saasInfo.remaining_effective_days <= (this.freeEdition ? 30 : 60);
			}
		},
		
		watch: {
			$route(val) {
				this.pageButtonList = [];
				this.parseRoute(val);
				this.updateNotice();
			},

			'$route.name': {
				handler(val) {
					if (!this.$route.meta.authFree && this.lock(val)) {
						this.freeEditionTips(true);
					}
				},
				immediate: true
			},

			navList() {
				this.parseRoute();
			}
		},
		
		created() {
			this.$store.dispatch('updateSystemConfig');
		},
		
		mounted() {
			this.parseRoute();
			window.addEventListener('click', () => {
				this.activeHeadButton = null;
			}, true);

			this.request({
				url: '/system/updateFlag',
				success: data => {
					this.updateLogDot = data;
				}
			});

			this.updateNotice();
			
			if (this.saasInfo.use_template_state == 2) {
				if (this.saasInfo.kf_bind_state == 2) {
					this.request({
						url: '/mini/getQr',
						data: {
							env_version: this.RE == 'Online' ? 'release' : 'trial'
						},
						loading: true,
						success: data => {
							this.request({
								url: '/sys_saas/detail',
								success: data => {
									this.loginInfo = data;
								}
							});
							this.followCode = data;
							this.$refs.follow.open();

							!function loop() {
								this._followRequest = this.request({
									url: '/sys_saas/bind/state',
									success: data => {
										if (data) {
											this.$refs.follow.close();
											this.initTemplate();
										} else {
											this._followTimer = setTimeout(() => {
												loop.call(this);
											}, 1000);
										}
									}
								});
							}.call(this);
						}
					});
				} else {
					this.initTemplate();
				}
			} else {
				this.request({
					url: '/system/updateLog',
					data: {
						pageIndex: 1,
						pageSize: 1
					},
					success: ([data]) => {
						if (localStorage.getItem('versionNotice') != data.version) {
							localStorage.setItem('versionNotice', data.version);
							this.$notice({
								title: '新版本已上线',
								message: data.remark.split('\n').splice(0, 2).map(item => `<p class="ellipsis">${item}</p>`).join('') + '<p>...完整内容可打开更新日志查看</p>',
								button: [{
									name: '立即查看',
									callback: () => {
										this.showUpdateLog();
									}
								}, {
									name: '稍后查看'
								}]
							});
						}
					}
				});

				if (this.renewRemind) {
					let date = new Date().format('yyyy-MM-dd');
					if (localStorage.getItem('renewRemind') != date) {
						localStorage.setItem('renewRemind', date);
						this.$refs.renewRemind.open();
					}
				}
			}

			this.$refs.updateLogList.parentNode.addEventListener('scroll', () => {
				if (this._updateLogRequest) return;

				let list = this.$refs.updateLogList.getBoundingClientRect(),
					scroll = this.$refs.updateLogList.parentNode.getBoundingClientRect();
				
				if (list.bottom < scroll.bottom + 500) {
					this._updateLogPageIndex++;
					this.loadUpdateLog();
				}
			});

			if (this.auth('b_factory_ai')) {
				const script = document.createElement('script');
				script.id = 'webChatScript';
				script.type = 'module';
				script.crossOrigin = 'anonymous';
				script.src = `/web-chatbot-ui_0.0.24.js?t=${new Date().getTime()}`;
				document.head.appendChild(script);
			}
		},

		beforeDestroy() {
			if (this.auth('b_factory_ai')) {
				document.getElementById('webChatScript').remove();
				document.getElementById('webChat-dialog').parentNode.remove();
			}
			this._followRequest && this._followRequest.abort();
			clearTimeout(this._followTimer);
			clearTimeout(this._noticeTimer);
		},
		
		methods: {
			parseRoute(route = this.$route) {
				this.alivePage = route.name;
				if (this.alivePage) {
					if (['home', 'g_tool'].includes(this.alivePage)) {
						this.aliveNav = this.alivePage;
					} else {
						let nav = this.navList.find(nav => {
							return nav.child_menu_list && nav.child_menu_list.find(menu => {
								return menu.child_menu_list && menu.child_menu_list.find(item => {
									return item.menu_unique_key == this.alivePage;
								});
							});
						});
						this.aliveNav = nav ? nav.menu_unique_key : '';
					}
				} else {
					this.aliveNav = '';
				}

				let crumb = this.aliveNav ? [this.aliveNavData.menu_name] : [];
				!function loop(index, list) {
					let item = route.matched[index];
					if (!item) return;
					if (item.meta.title) {
						crumb.push(item.meta.title)
					} else if (list && item.name) {
						let menu = list.find(temp => temp.menu_unique_key == item.name);
						if (menu) {
							crumb.push(menu.menu_name);
							list = menu.child_menu_list;
						}
					}
					loop(++index, list);
				}(0, this.aliveNavData.child_menu_list);
				this.crumbList = crumb;

				if (this.windowPage && crumb.length) {
					document.title = `${crumb[crumb.length - 1]} - 蜂鸟生产工单`;
				}

				if (route.meta.appView && this.auth(route.meta.appView.auth)) {
					this.appViewConfig = route.meta.appView;
				} else {
					this.appViewConfig = false;
				}

				if (
					route.meta.templateManage &&
					(
						(route.meta.templateManage.print && this.auth(route.meta.templateManage.print)) ||
						(route.meta.templateManage.export && this.auth(route.meta.templateManage.export))
					)
				) {
					this.templateConfig = route.meta.templateManage;
				} else {
					this.templateConfig = false;
				}
			},

			navHandle(nav) {
				if (['home', 'g_tool'].includes(nav.menu_unique_key)) {
					if (this.$route.name == nav.menu_unique_key) {
						this.aliveNav = nav.menu_unique_key;
					}
					this.navigateTo({
						name: nav.menu_unique_key
					});
				} else if (this.aliveNav == nav.menu_unique_key) {
					this.aliveNav = '';
				} else {
					this.aliveNav = nav.menu_unique_key;
				}
			},

			menuHandle(item, win) {
				if (item.type == 'kanban') {
					if (!item.is_builtin && this.lock(item.menu_unique_key)) {
						this.freeEditionTips();
						return;
					}

					if (win) {
						window.open(`/digital/${item.id}`);
					} else {
						this.navigateTo(`/digital/${item.id}`);
					}
					return;
				}

				if (win) {
					this.windowTo({
						name: item.menu_unique_key
					});
				} else {
					this.alivePage = item.menu_unique_key;
					this.navigateTo({
						name: item.menu_unique_key
					});
				}
			},

			headButtonHandle(item) {
				if (item.lock) {
					this.freeEditionTips();
					return;
				}
				if (item.list) {
					this.activeHeadButton = item;
				} else {
					this.activeHeadButton = null;
				}
				item.handle && item.handle();
			},
			
			logout() {
				this.$confirm({
					message: '确定要退出登录吗？',
					resolve: () => {
						this.request({
							url: '/sys_user/logout',
							loading: true,
							success: () => {
								this.$store.commit('setSession', '');
								this.navigateTo('/login');
							}
						});
					}
				});
			},
			
			resetPassword(stop) {
				stop();
				this.$refs.resetPswForm.submit({
					url: '/sys_user/update_pwd',
					rule: {
						old_pwd: '请填写旧密码',
						user_pwd: '请填写新密码',
						confirm_pwd: [{
							type: 'empty',
							message: '请在填写一次新密码'
						}, {
							type: 'function',
							fun: (value, data) => {
								return data.user_pwd == value
							},
							message: '两次输入的新密码不一致'
						}]
					},
					dataFormatter: data => {
						data.old_pwd = cryptoJs.MD5(data.old_pwd).toString();
						data.user_pwd = cryptoJs.MD5(data.user_pwd).toString();
						delete data.confirm_pwd;
						return data;
					},
					success: () => {
						this.$message({
							type: 'success',
							message: '密码修改成功'
						});
						this.$refs.resetPsw.close();
					}
				});
			},

			showUpdateLog() {
				if (!this.updateLog.length) {
					this._updateLogPageIndex = 1;
					this.loadUpdateLog();
				}
				this.$refs.updateLog.open();
			},

			loadUpdateLog() {
				this._updateLogRequest = this.request({
					url: '/system/updateLog',
					data: {
						pageIndex: this._updateLogPageIndex
					},
					loading: this._updateLogPageIndex == 1,
					success: data => {
						if (data.length) {
							delete this._updateLogRequest;
						}
						this.updateLog = this.updateLog.concat(data);
					}
				});
			},

			updateNotice() {
				clearTimeout(this._noticeTimer);
				this.request({
					url: '/system/notice',
					success: data => {
						this.notice = data ? data.sub_title : '';
						if (this.notice) {
							this.$nextTick(() => {
								let $notice = this.$refs.notice;
								if (!this._noticeScroll) {
									this._noticeScroll = () => {
										this.noticeScroll = $notice.clientWidth > $notice.parentElement.parentElement.clientWidth ? $notice.clientWidth : 0;
									}
									window.addEventListener('resize', this._noticeScroll);
								}
								this._noticeScroll();
							});
						} else {
							window.removeEventListener('resize', this._noticeScroll);
							delete this._noticeScroll;
						}

						this._noticeTimer = setTimeout(() => {
							this.updateNotice();
						}, 30 * 60 * 1000);
					}
				});
			},

			async helpDocHandle(type) {
				this.helpDocSrc = (await this.request({
					url: '/operations/guide'
				})).data[type];
				this.helpDocSrc && this.$refs.helpDoc.open();
			},

			setHeadButton(data) {
				this.pageButtonList = data.filter(item => this.auth(item.auth)).map(item => {
					item.lock = this.lock(item.auth);
					return item;
				});
			},

			initTemplate() {
				this.$confirm({
					type: 'warn',
					message: '首次使用系统需要选择应用一套行业方案',
					buttonName: '前往应用',
					cancelButton: false,
					resolve: () => {
						this.navigateTo('/system/factory');
					}
				});
			},

			copyHandle() {
				this.$copy([
					'电脑端登录地址：https://web.ycmes.cn',
					'移动端登录地址：https://app.ycmes.cn',
					`工厂代码：${this.loginInfo.saas_id}`,
					`账号：${this.loginInfo.user_name}`,
					`密码：${this.loginInfo.pwd}`
				].join('\n'));
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.g-page {
		height: 100vh;
		
		.g-nav {
			z-index: 100;
			position: relative;
			width: 110px;
			background: #242738;

			.logo {
				position: relative;
				padding: 10px;
				cursor: pointer;

				&-image {
					position: relative;
					width: 100%;
					height: 50px;
				
					img {
						height: 100%;
					}
				}

				.tag {
					position: absolute;
					left: 0;
					top: 0;
					border-radius: 0 12px 12px 0;
					padding: 0 9px 0 6px;
					line-height: 24px;
					font-size: 14px;
					font-weight: 500;
					white-space: nowrap;
				}

				.edit {
					display: none;
					position: absolute;
					right: 0;
					top: 0;
					width: 24px;
					height: 24px;
					border-bottom-left-radius: 12px;
					font-size: 12px;
					color: #fff;
					background: #0D6EFE;

					^[-1]:hover ^[-1..-1] {
						display: flex;
					}
				}

				.name {
					margin-top: 10px;
					line-height: 20px;
					font-size: 15px;
					font-weight: bold;
					text-align: center;
					color: #fff;
				}
			}
			
			.nav {
				margin: 10px 0;

				.item {
					gap: 10px;
					height: 36px;
					border-radius: 4px;
					padding: 0 6px;
					margin: 0 6px;
					font-size: 15px;
					color: #DEDCED;
					cursor: pointer;
					transition: all .3s ease;

					&:nth-child(n+2) {
						margin-top: 10px;
					}

					&:not(.z-alive):hover {
						color: #0FCF73;
					}

					&[group] {
						gap: 8px;
						margin-top: 40px;
						font-size: 14px;

						+ .item[group] {
							margin-top: 10px;
						}
					}

					&.z-alive {
						color: #fff;
						background: #0FCF73;
						box-shadow: 0 5px 8px 0 rgba(15,207,115,.3);
					}
					
					.icon {
						width: 1em;
						font-size: 16px;
						text-align: center;

						^[-1].z-alive ^[-1..-1]:before {
							color: #fff;
						}
					}
				}
			}

			.bottom {
				height: 44px;
				border-top: 1px solid rgba(255,255,255,.2);

				img {
					height: 36px;
					opacity: .8;
				}
			}
		}

		.g-menu {
			z-index 51;
			position: relative;
			width: 140px;
			border-right: 1px solid #ddd;

			&-title {
				border-bottom: 1px solid #ddd;
				padding: 0 12px;
				line-height: 50px;
				font-size: 16px;
				font-weight: bold;
			}

			&-list {
				.item {
					&:nth-child(1) {
						padding-top: 10px;
					}

					dt {
						padding: 0 10px;
						line-height: 36px;
						font-size: 14px;
						color: #999;
					}
					
					dd {
						overflow: hidden;
						transition: height .3s ease;
						
						^[-1].z-alive ^[-1..-1] {
							height: auto;
						}

						ul {
							padding-bottom: 10px;
						}
						
						li {
							position: relative;
							height: 36px;
							padding: 0 8px 0 28px;
							font-size: 13px;
							line-height: 18px;
							color: #444;
							cursor: pointer;
							transition: all .3s ease;
							
							&:hover,
							&.z-alive {
								color: var(--color-main);
							}

							&:before {
								content: '';
								position: absolute;
								left: 12px;
								top: 50%;
								width: 5px;
								height: 2px;
								border-radius: 1px;
								margin-top: -1px;
								background: #5C5E6B;
								transition: all .2s ease;

								^[-1]:hover^[-1..-1],
								^[-1].z-alive^[-1..-1] {
									width: 10px;
									background: var(--color-main);
								}
							}

							.vip {
								height: 14px;
								margin-left: 6px;
							}

							.window {
								position: absolute;
								right: 0;
								top: 50%;
								border-radius: 50%;
								padding: 10px;
								font-size: 16px;
								color: #999;
								transform: translate(0,-50%);

								&:hover {
									color: var(--color-main);
								}
							}
						}
					}
				}
			}
		}
		
		.g-head {
			z-index 50;
			position: relative;
			height: 50px;
			background: #fff;
			box-shadow: 0 1px 5px 0 rgba(0,0,0,.1);

			.head-crumb {
				gap: 10px;
				padding-left: 16px;
				color: #999;

				p:nth-last-child(1) {
					color: #000;
				}
			}
			
			.head-button {
				position: relative;

				&:nth-child(n+2) {
					margin-left: 20px;
				}

				&-main {
					position: relative;
					height: 50px;
					font-size: 13px;
					color: #444;
					cursor: pointer;

					^[-1]:hover ^[-2..-1],
					^[-1][active] ^[-2..-1] {
						color: var(--color-main);
					}

					.icon {
						font-size: 16px;

						+ span {
							margin-left: 6px;
						}
					}

					.error {
						position: absolute;
						left: 8px;
						top: 12px;
						font-size: 12px;
						color: #f00;
					}

					.vip {
						height: 14px;
						margin-left: 4px;
					}
				}

				&-list {
					display: none;
					z-index: 90;
					position: absolute;
					left: 0;
					top: 100%;
					border: 1px solid #eee;
					background: #fff;
					box-shadow: 0 5px 5px 0 rgba(0,0,0,.05);

					^[-1][active] ^[-1..-2] {
						display: block;
					}

					li {
						height: 36px;
						padding: 0 16px;
						white-space: nowrap;
						font-size: 13px;
						color: #444;
						cursor: pointer;

						&:nth-child(n+2) {
							border-top: 1px solid #eee;
						}

						&:hover {
							color: var(--color-main);
						}
					}
				}

				&-service {
					display: none;
					z-index: 90;
					position: absolute;
					left: -20px;
					top: 100%;
					box-sizing: border-box;
					width: 160px;
					padding: 12px 0;
					border: 1px solid #eee;
					background: #fff;
					box-shadow: 0 5px 5px 0 rgba(0,0,0,.05);

					^[-1]:hover ^[-1..-2] {
						display: block;
					}

					li {
						position: relative;
						padding: 0 20px;
						white-space: nowrap;
						line-height: 36px;
						font-size: 13px;
						color: #444;
						cursor: pointer;

						&:hover {
							color: var(--color-main);
						}

						.mobile {
							display: none;
							position: absolute;
							left: 100%;
							top: 0;
							box-sizing: border-box;
							border: 1px solid #ddd;
							line-height: initial;
							font-size: 0;
							background: #fff;

							^[-1]:hover ^[-1..-1] {
								display: block;
							}

							.qrcode {
								width: 130px;
								max-width: none;
								height: 130px;
							}

							p {
								padding-bottom: 5px;
								line-height: 22px;
								font-size: 12px;
								text-align: center;
								color: #666;

								span {
									color: #f55;
								}
							}
						}
					}
				}

				&-line {
					width: 1px;
					height: 50px;
					margin: 0 15px;
					background: linear-gradient(0deg, #FFFFFF, #DDDDDD, #FFFFFF);

					+ .head-button {
						margin-left: 0;
					}
				}
			}

			.head-ai {
				height: 50px;
				margin-left: 25px;
				cursor: pointer;

				img {
					height: 20px;
					transition: transform .1s ease;

					^[-1]:hover ^[-1..-1] {
						transform: scale(1.2);
					}
				}
			}
			
			.user-info {
				z-index: 100;
				position: relative;
				height: 50px;
				padding: 0 20px;
				cursor: pointer;
				transition: all .3s ease;
				
				&:hover {
					.menu {
						display: block;
					}
				}
				
				.icon {
					width: 34px;
					height: 34px;
					border-radius: 100%;
					overflow: hidden;
					background: #000;
				}
				
				.name {
					margin: 0 6px 0 10px;
					font-size: 13px;
				}
				
				.arrow {
					font-size: 11px;
				}
				
				.menu {
					display: none;
					z-index: 12;
					position: absolute;
					left: 0;
					right: 0;
					top: 100%;
					border: 1px solid #eee;
					padding: 8px 0;
					color: #000;
					background: #fff;
					box-shadow: 0 5px 5px 0 rgba(0,0,0,.05);
					
					.item {
						position: relative;
						padding: 0 10px 0 16px;
						line-height: 36px;
						font-size: 13px;
						color: #333;
						
						&:hover {
							color: var(--color-main);
						}
						
						.dot {
							position: absolute;
							right: 20px;
							top: 50%;
							width: 6px;
							height: 6px;
							border-radius: 100%;
							background: #f00;
							transform: translate(0, -50%);
						}
					}
				}
			}
		}

		.g-notice {
			gap: 10px;
			height: 30px;
			padding: 0 12px;
			line-height: 20px;
			font-size: 12px;
			color: #f55;
			background: #FFFADB;

			.tf {
				font-size: 16px;
			}

			.content {
				overflow: hidden;
				white-space: nowrap;

				&-scroll {
					transform: translate(0, 0);
					animation-name: loopScroll;
					animation-timing-function: linear;
					animation-iteration-count: infinite;

					@keyframes loopScroll {
						0% {
							transform: translate(0, 0);
						}
						100% {
							transform: translate(-50%, 0);
						}
					}
				}

				p:nth-child(2),
				p:nth-last-child(2) {
					margin-right: 50px;
				}
			}
		}
		
		.g-content {
			overflow: auto;
			background: #F5F4F7;
		}
	}

	.update-log {
		margin: 10px 20px;

		dt {
			height: 50px;

			.version {
				font-size: 18px;
				font-weight: bold;
				color: var(--color-main);
			}

			.date {
				font-size: 13px;
				color: #999;

				.tf {
					margin-right: 6px;
				}
			}
		}

		dd {
			border-radius: 8px;
			padding: 20px 24px;
			line-height: 22px;
			font-size: 14px;
			white-space: pre-wrap;
			color: #333;
			background: #F9F9F9;

			^[-1]:nth-child(1) ^[-1..-1] {
				color: #01A27D;
				background: #F1FAF8;
			}
		}
	}

	.help-doc {
		display: block;
		width: 100%;
		height: 100%;
		border: none;
	}

	.service-code {
		padding: 30px 0 20px;

		.icon {
			font-size: 48px;
			color: #00BB00;
		}

		h1 {
			margin-top: 20px;
			font-size: 16px;
		}

		img {
			width: 130px;
			height: 130px;
			border: 5px solid #D9F2EC;
			border-radius: 6px;
			margin: 18px 0 9px;
		}

		p {
			font-size: 13px;
			color: #999;
		}
	}

	.custom-service {
		padding: 30px 0 18px;

		.icon {
			font-size: 48px;
			color: #00BB00;
		}

		h1 {
			margin-top: 12px;
			font-size: 22px;
		}

		h2 {
			width: 310px;
			margin-top: 10px;
			line-height: 20px;
			font-size: 13px;
			font-weight: normal;
			text-align: center;
			color: #666;
		}

		img {
			width: 130px;
			height: 130px;
			border: 5px solid #D9F2EC;
			border-radius: 6px;
			margin: 20px 0 9px;
		}

		p {
			font-size: 13px;
			color: #999;
		}

		.tel {
			gap: 10px;
			width: 340px;
			height: 50px;
			border-radius: 6px;
			margin-top: 16px;
			font-size: 22px;
			color: #fff;
			background: var(--color-main);
		}
	}

	.follow {
		border-radius: 10px;
		padding: 0 35px;
		background: linear-gradient(180deg, #F2FFFC, #FFFFFF);

		&-title {
			padding: 35px 0 25px;
			font-size: 28px;
		}

		&-content {
			width: 100%;
			border: 2px solid #00B38A;
			border-radius: 16px;
			overflow: hidden;
			background: #fff;
		}

		&-account {
			box-sizing: border-box;
			width: 100%;
			padding: 14px 24px;
			line-height: 30px;
			font-size: 14px;
			color: #333;

			.tf {
				margin-right: 12px;
				color: #999;
			}
		}

		&-code {
			padding-bottom: 15px;
			background: #00B38A;

			dt {
				padding: 15px 0;
				font-size: 20px;
				font-weight: bold;
				text-align: center;
				color: #fff;
				
				span {
					color: #FFF600;
				}
			}

			dd {
				img {
					width: 186px;
					height: 186px;
					border-radius: 8px;
				}
			}
		}

		&-bottom {
			gap: 10px;
			padding: 20px 0 16px;

			.tf {
				font-size: 26px;
				color: #00CF5D;
			}

			p {
				font-size: 18px;
				font-weight: bold;
			}
		}

		&-rights {
			width: 360px;
			padding-bottom: 20px;

			li {
				gap: 8px;
				height: 28px;
				font-size: 13px;
				color: #3D9A85;
			}
		}
	}
</style>
